import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'indianCurrency',
})
export class IndianCurrencyPipe implements PipeTransform {
  transform(
    value: number | string | null | undefined,
    currencyCode: string = '₹',
    symbolDisplay: boolean = true
  ): string {
    if (value == null) {
      return '';
    }

    // Convert to string and check for negative
    let strValue = String(value);
    const isNegative = strValue.startsWith('-');

    // Remove negative sign for formatting
    if (isNegative) {
      strValue = strValue.substring(1);
    }

    let [integer, fraction = ''] = strValue.split('.');

    // Add comma after every two digits from the right, except the last three digits
    let lastThree = integer.slice(-3);
    let otherNumbers = integer.slice(0, -3);
    if (otherNumbers !== '') {
      lastThree = ',' + lastThree;
    }
    let result = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;

    if (fraction) {
      result += '.' + fraction;
    }

    // Add currency symbol
    const formatted = symbolDisplay ? `${currencyCode}${result}` : result;

    // Add negative sign in front of the symbol
    return isNegative ? `-${formatted}` : formatted;
  }
}
